import { orchestratorEndpoint } from '../../lib';
import type { OrchestratorFlowDataT, OrchestratorResponseDataT } from '../../orchestrator/shared/types';

// Synthetic — these mirror the orchestrator's response shapes only and must never contain real data.
const mockFlowId = 'a4a4b1e0-3c1a-4a7a-9a1a-3a1a4a4b1e03';

// A sign cnuapp failed without deciding anything (here, an HTML 500 page the orchestrator couldn't
// parse). The orchestrator still answers with a 200: cnuapp's own `{ code, response }` for the sign
// call, plus the `error` its client adds when cnuapp never really answered, sits at the top of `data`
// and the flow falls back to the contract step.
export const mockCnuappDownSignResponse: OrchestratorResponseDataT<OrchestratorFlowDataT> = {
  data: {
    code: 503,
    error: ['unparsable response'],
    flow_uuid: mockFlowId,
    intent_name: 'organic',
    response: {},
  },
  errors: [],
  flowUUID: mockFlowId,
  route: 'contract',
};

// The orchestrator's own 500 (render_orc_error), sent with that HTTP status.
export const mockOrchestratorErrorSignResponse: OrchestratorResponseDataT<OrchestratorFlowDataT> = {
  data: {},
  errors: ['orc_500'],
  flowUUID: mockFlowId,
  route: 'contract',
};

// MSW's own path-parameter syntax, not a real flowId — see currentStepPattern.
export const contractSignPattern = orchestratorEndpoint('/loan_application/:flowId/contract');
